<template>
  <div class="statis-student">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem :label-width="0">
        <Input
          v-model="searchCondition.keywords"
          placeholder="请输入关键字"
          style="width:250px;"
          clearable
          @keydown.native.prevent.enter="onSearch"
        >
          <Select v-model="searchCondition.keywords_type" slot="prepend" style="width:90px;">
            <Option v-for="item in keywordsType" :value="item.key" :key="item.key">{{item.value}}</Option>
          </Select>
        </Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div>
      <Button type="primary" @click="onExport" class="btn-margin-right">批量导出</Button>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/user/statics"
        :search="searchCondition"
        selectType
        keyField="id"
        method="post"
      >
        <template slot-scope="{row}" slot="action">
          <div>
            <Button type="text" size="small" @click="onRecord(row)">学习记录</Button>
          </div>
        </template>
      </Grid>
    </div>
    <Modal v-model="modal.show" title="学习记录" width="800">
      <div>
        <Button type="primary" @click="onExportRecord">批量导出</Button>
      </div>
      <div class="content">
        <Grid
          ref="modalGrid"
          :columns="modal.columns"
          :data-url="modal.dataUrl"
          :search="modal.searchCondition"
          :rowsFormatter="onModalRowsFormatter"
          selectType
          keyField="course_basis_id"
          method="get"
        ></Grid>
      </div>
    </Modal>
  </div>
</template>

<script>
import { CouseType } from "@/utils/enums";

export default {
  name: "statis-student",
  data() {
    return {
      searchCondition: {
        keywords_type: "nickname",
        keywords: "",
        init: function() {
          this.keywords_type = "nickname";
          this.keywords = "";
        }
      },
      keywordsType: [
        { key: "nickname", value: "学员名称" },
        { key: "mobile", value: "手机号码" }
      ],
      tableColumns: [
        { title: "学员名称", key: "nickname", minWidth: 120 },
        { title: "手机号码", key: "mobile", align: "center", minWidth: 120 },
        {
          title: "学习课程",
          key: "course_num",
          align: "center",
          minWidth: 140
        },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 100,
          fixed: "right"
        }
      ],
      modal: {
        show: false,
        columns: [
          { title: "课程名称", key: "title", minWidth: 120 },
          { title: "课程类型", key: "course_type_name", minWidth: 100 },
          { title: "课时数量", key: "chapter_total", minWidth: 100 },
          { title: "学习进度", key: "study_ratio", minWidth: 120 }
        ],
        dataUrl: "",
        searchCondition: {
          user_id: ""
        }
      }
    };
  },
  created() {
    if (this.$route.query.nickname) {
      this.searchCondition.keywords_type = "nickname";
      this.searchCondition.keywords = this.$route.query.nickname;
    }
  },
  methods: {
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onRecord(row) {
      this.modal.show = true;
      this.modal.searchCondition.user_id = row.id;
      this.modal.dataUrl = "/api/user/study";
      this.$nextTick(() => {
        this.$refs.modalGrid.searchRefresh();
      });
    },
    onExport() {
      if (!this.$refs.grid.getTotal()) {
        this.$Message.info("暂无数据可导出");
        return;
      }
      this.$http
        .post("/api/user/statics/export", this.searchCondition)
        .then(data => {
          window.open(data.url);
        });
    },
    onExportRecord() {
      if (!this.$refs.modalGrid.getTotal()) {
        this.$Message.info("暂无数据可导出");
        return;
      }
      this.$http
        .get("/api/user/study/export/" + this.modal.searchCondition.user_id)
        .then(data => {
          window.open(data.url);
        });
    },
    onModalRowsFormatter(rows) {
      rows.forEach(i => {
        i.course_type_name = CouseType.getValue(i.course_type);
        i.study_ratio = parseInt(i.study_ratio * 100) + "%";
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>